import { css } from '@linaria/core';
import { PAGE_MAX_WIDTH_COLLAPSED, PAGE_GUTTER_PADDING, PAGE_MAX_WIDTH_EXPANDED, SIDEBAR_AUTO_COLLAPSE_WIDTH, PAGE_TOP_PADDING, PAGE_BOTTOM_PADDING } from './constants';
import { breakpoints } from './utils';
export const pageStyles = {
  wrapper: "tyles__shared_ts-wrapper-wkvq9oe"
};

// Visually hide browser scrollbars (they still functional)
export const hideScrollBars = "tyles__shared_ts-hideScrollBars-h1vg0fhj";

require("./shared.linaria.module.css!=!../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./shared.ts");